import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Optional, Output, Self } from '@angular/core';
import { ControlValueAccessor, UntypedFormBuilder, UntypedFormControl, NgControl } from '@angular/forms';
import { QuestionTypeEnum } from '../../../../enums/question-type.enum';
import { IQuestion } from '../../../../interfaces/question.interface';
import { SortDirectionEnum } from '../../../../enums/sort-direction.enum';

export const NOOP_VALUE_ACCESSOR: ControlValueAccessor = {
  writeValue(): void {},
  registerOnChange(): void {},
  registerOnTouched(): void {},
};

@Component({
  selector: 'check-lists-question',
  templateUrl: './check-lists-question.component.html',
  styleUrls: ['./check-lists-question.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckListsQuestionComponent implements OnInit {
  @Input() question: IQuestion;
  @Input() isChecklist: boolean;
  @Input() canMove: boolean;

  @Output() sorted = new EventEmitter<SortDirectionEnum>();
  @Output() moved = new EventEmitter<IQuestion>();
  @Output() required: EventEmitter<boolean> = new EventEmitter<boolean>();

  questionTypes = QuestionTypeEnum;
  sortDirection = SortDirectionEnum;
  requiredControl: UntypedFormControl;

  get control(): UntypedFormControl {
    return this.ngControl.control as UntypedFormControl;
  }

  constructor(
    @Self() @Optional() public ngControl: NgControl,
    private fb: UntypedFormBuilder
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = NOOP_VALUE_ACCESSOR;
    }
  }

  ngOnInit() {
    this.requiredControl = this.fb.control({
      value: this.question.is_required,
      disabled: this.control.disabled,
    });
  }

  handleChange(evt: Event) {
    this.required.emit((evt.target as HTMLInputElement).checked);
  }
}
